import axios from "axios";
import { AuthResponse, TokenResponse } from "@/models";


export default class AuthenticationService {
    public async requestToken(email: string, pin: string): Promise<TokenResponse> { 
        const result = (await axios.post<TokenResponse>("authentication/pin",
            { email, pin })).data;

        return result;
    }

    public async authenticate(deviceId: string, pushToken: string | null): Promise<AuthResponse> {
        return (await axios.post<AuthResponse>("authentication/authenticate", {deviceId: deviceId, pushToken: pushToken})).data;
    }

    public async test(): Promise<string> {
        return (await axios.get<string>("authentication/test")).data;
    }

    public async testpost(): Promise<string> {
        return (await axios.post<string>("authentication/testpost", {username: "user1", pin: "pin1"})).data;
    }
}
